// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OFCs","title":"styles_title__25q9k"};